// extracted by css-extract-rspack-plugin
export default {"tabList":"_c5e2e262","fullWidth":"_7212f162","center":"_4bb0efbc","container":"_4f4565f0","left":"_3b9dc6ac","overflowContainer":"_7404ef2c"};